
import divSpan from '@/components/DivSpan';
import materialSourceAllocationTp from '@/components/page-temporary/material-source-allocation-tp'
import Popup from 'vux/src/components/popup/index.vue'

export default {
name: "material-source-allocation",
components: {
divSpan,
materialSourceAllocationTp,
Popup
},
data() {
return {
wrapperHeight: 0,
allLoaded: false,
config: {
title: '货源管理',
url: 'api/supply-control/page',
workflowSearchBean: {},
fixRules: [],
inputCondition: {
placeholder: '物料编号/名称',
searchCondition: 'key',
rules: [{
field: "material.matCode-material.matName",
option: "LIKE_ANYWHERE"
}]
},
},
searchData: {},
detailDto: {},
list: [],
showDetail: false,
}
},
methods: {
goDetail(data){
this.showDetail = !this.showDetail;
this.detailDto = data;
},
closeQual(){
this.showDetail = false;
},
getList(e,met,bol){
this.$nextTick(()=>{
if(bol){
this.list = this.list.concat(e);
}else{
this.list = e;
}
if(met === 'top'){
this.$refs.loadmore.onTopLoaded();
}
if(met === 'bottom'){
this.$refs.loadmore.onBottomLoaded();
}
})
},
init: function () {

this.wrapperHeight = document.documentElement.clientHeight - this.$refs.wrapper.getBoundingClientRect().top - 10;
},
loadTop() {
this.$refs.header.getlist(true);
},
loadBottom() {
this.$refs.header.getMore();
}
},
mounted() {
this.init();
this.$refs.header.getlist();
}
}



// WEBPACK FOOTER //
// ./src/page/material-source-allocation/material-source-allocation.vue